import { Container, Row, Col } from "react-bootstrap";
import "./OffersPromotions.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function OffersPromotions() {
            const navigate = useNavigate();
  
  useEffect(() => {
    AOS.init({
      duration: 1200,
      easing: "ease-in-out",
      once: true,
      offset: 80,
    });
  }, []);

  return (
    <div className="container-fluid">
      <section className="offers-section mt-5">
        <Container fluid className="px-lg-5" data-aos="fade-down">
          <Row className="justify-content-center text-center">
            {/* FULL WIDTH CONTENT */}
            <Col lg={8} md={12} className="text-white">
              <h1 className="offers-title-okkk">Offers & Promotions</h1>

              <p className="offers-desc">
                Check out the latest discounts and promotions on offers from
                fresh clean. Send us a message if you require any information.
              </p>

              <p className="offers-sub">Try the fresh clean Experience Today</p>

              <div className="app-group">
                {/* WhatsApp Order Button */}
                <button
                  className="btn primary order-offers"
                  onClick={() =>
                    window.open("https://wa.me/0545718455", "_blank")
                  }
                >
                  Order
                </button>

                {/* Pricing Page Button */}
                <button
                  className="btn secondary pricing-offers"
                 onClick={() => navigate("/laundry-price")}
                >
                  Pricing
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
